import { faQuestionCircle, faXmark } from "@fortawesome/pro-regular-svg-icons";

import { DOCS_FUNDAMENTALS_DECISION_HISTORY } from "src/constants/ExternalLinks";
import { IconButton, IconLink } from "src/design-system/Icon";

export const Header = ({ onRequestClose }: { onRequestClose: () => void }) => (
  <div>
    <div className="mb-2 flex items-start justify-around px-6">
      <div className="grow">
        <div className="mt-0.5 font-inter-semibold-16px text-gray-800">
          Decision history
        </div>
        <div className="mt-1 font-inter-normal-12px text-gray-500">
          A record of every decision made by this particular version of the
          Decision Flow. Usually, new decisions can take a few seconds to
          appear.
        </div>
      </div>

      <div className="mt-1 flex flex-row items-center gap-x-2">
        <IconLink
          aria-label="Decision history documentation"
          href={DOCS_FUNDAMENTALS_DECISION_HISTORY}
          icon={faQuestionCircle}
          openInNewTab
          size="xs"
        />
        <IconButton
          dataLoc="close-decision-history-side-pane"
          icon={faXmark}
          size="xs"
          onClick={onRequestClose}
        />
      </div>
    </div>
    <div className="mt-4 mb-1 px-6">
      <div className="h-px w-full rounded-full bg-gray-100"></div>
    </div>
  </div>
);
